export default __webpack_public_path__ + "static/media/thumbnail-m-chair@3x.60cb8677.png";